import type { ErrorInfo } from "../types";

type ErrorTypeInfoProps = {
  errorInfo: ErrorInfo;
};

export function ErrorTypeInfo({ errorInfo }: ErrorTypeInfoProps) {
  const { errorType, errorName, statusCode } = errorInfo.devDetails;

  return (
    <div>
      <h4 className="mb-2 font-semibold text-red-800">Error Type:</h4>
      <div className="rounded bg-white p-3 font-mono text-sm">
        <div className="mb-1">
          <span className="font-semibold">Type:</span> {errorType}
        </div>
        <div>
          <span className="font-semibold">Name:</span> {errorName}
        </div>
        {statusCode && (
          <div>
            <span className="font-semibold">Status Code:</span> {statusCode}
          </div>
        )}
      </div>
    </div>
  );
}
